import { Link } from "react-router-dom";

const SERVICES = [
  {
    title: "Penetration Testing",
    desc: "Simulated cyberattacks to uncover vulnerabilities before adversaries do. Full scoping, exploitation, and executive reporting.",
    to: "/services/penetration-testing",
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M12 2L3 7v6c0 5.25 3.75 10.05 9 11 5.25-.95 9-5.75 9-11V7l-9-5z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: "GRC",
    desc: "Governance, risk and compliance frameworks aligned to ISO 27001, NIST and SOC 2. From gap analysis to audit readiness.",
    to: "/services/grc",
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <path d="M9 14l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: "Cybersecurity Maturity Assessment",
    desc: "Benchmark your security posture against CMMI, NIST CSF or ENISA frameworks with an actionable remediation roadmap.",
    to: "/services/cybersecurity-maturity-assessment",
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M3 3v18h18" />
        <path d="M7 16l4-5 4 3 5-7" />
      </svg>
    ),
  },
  {
    title: "Data Privacy",
    desc: "GDPR, CCPA, HIPAA and global regulation compliance. Privacy impact assessments, policy drafting and data mapping.",
    to: "/services/data-privacy",
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0110 0v4" />
        <circle cx="12" cy="16" r="1" />
      </svg>
    ),
  },
  {
    title: "Cybersecurity for Startups",
    desc: "Security-first foundations for fast-moving teams. Cloud config, policy templates, compliance packs and virtual CISO.",
    to: "/services/cybersecurity-for-startups",
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    ),
  },
  {
    title: "Cybersecurity for AI",
    desc: "Threat modelling for ML pipelines, LLM red-teaming, AI governance frameworks and responsible deployment guardrails.",
    to: "/services/cybersecurity-for-ai",
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <rect x="4" y="4" width="16" height="16" rx="2" />
        <path d="M9 9h6v6H9z" />
        <path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3" />
      </svg>
    ),
  },
];

export default function ServicesSection() {
  return (
    <section className="bg-black" id="services">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-10 py-12 sm:py-22">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-start">
          {/* Left — header */}
          <div>
            <div
              className="font-mono text-[12px] text-[#71717a] mb-5"
              style={{ letterSpacing: "0.18em" }}
            >
              02 — PROFESSIONAL SERVICES
            </div>
            <h2
              className="font-bold text-white mb-5"
              style={{
                fontSize: "clamp(30px, 3.7vw, 46px)",
                lineHeight: 1.06,
                letterSpacing: "-0.03em",
              }}
            >
              Enterprise cybersecurity,
              <br className="hidden sm:block" /> built by practitioners
            </h2>
            <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#a1a1aa] max-w-[520px] mb-6">
              Beyond training, Hack Defense delivers hands-on security services to
              organisations worldwide — from startups to enterprises. Every engagement
              is led by the same practitioners who teach the courses.
            </p>
            <Link
              to="/services"
              className="inline-block border border-[#3f3f46] text-white px-[22px] py-3 rounded-[7px] text-[14px] font-semibold hover:border-white transition-colors"
            >
              View all services →
            </Link>
          </div>

          {/* Right — empty space on large screens, keeps grid balanced */}
          <div className="hidden md:block" />
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {SERVICES.map((s) => (
            <Link
              key={s.title}
              to={s.to}
              className="group border border-[#27272a] rounded-[14px] bg-[#09090b] p-7 flex flex-col gap-4 hover:border-[#3f3f46] transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center border border-[#3f3f46] rounded-[10px] text-[#a3e635]">
                {s.icon}
              </span>
              <h3 className="text-[19px] sm:text-[21px] font-bold text-white" style={{ letterSpacing: "-0.02em" }}>
                {s.title}
              </h3>
              <p className="text-[15px] leading-[1.65] text-[#a1a1aa] flex-1">
                {s.desc}
              </p>
              <span className="text-[#a3e635] text-[14px] font-semibold group-hover:underline">
                Learn more →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
